import { IonButton, IonContent, IonImg } from "@ionic/react";
import paperIcon from '../../assets/images/paper.png';
interface Props {
  setShowModal: Function;
}
const MeasuringTape: React.FC<Props> = ({ setShowModal }) => {
  return (
    <IonContent placeholder={undefined}>
      <div className="assessment-tape-wrap">
        <div className="text-center">
        <IonImg src={paperIcon} alt="paperIcon" placeholder={undefined}></IonImg>
        </div>
        <h1>8.5” x 11” PAPER</h1>
        <p>An 8.5” x 11” piece of paper is needed to calibrate the starting and ending positions for the assessment.</p>
        <IonButton
          className="generic-btn"
          onClick={() => setShowModal(false)} placeholder={undefined}        >
          Close
        </IonButton>
      </div>
    </IonContent>
  );
};
export default MeasuringTape;
